/* eslint-disable no-param-reassign */
import { resetCacheItem } from './cacheManager';

export default ({ cache }) => {
  if (cache.isMounted) return;
  if (cache.lifeTime === Infinity) return;
  cache.garbageCollectionId = setTimeout(() => {
    resetCacheItem(cache.cacheKey);
  }, cache.lifeTime);
};
